import React from 'react';

function getEventClass(eventType) {
  if (eventType === 'validation_verified' || eventType === 'account_holder_confirmed') return 'event-safe';
  if (eventType === 'action_selected') return 'event-help';
  if (eventType === 'dtmf') return 'event-dtmf';
  if (eventType === 'failed' || eventType === 'invalid_input') return 'event-error';
  return '';
}

function CallTimeline({ events }) {
  if (!events || events.length === 0) {
    return <p className="text-muted fst-italic">No events yet</p>;
  }

  return (
    <div className="timeline">
      {events.map((event, idx) => (
        <div key={event._id || idx} className={`timeline-item ${getEventClass(event.event_type)}`}>
          <div className="d-flex justify-content-between align-items-start">
            <div>
              <strong className="d-block">{event.description}</strong>
              {event.details && event.details.digit && (
                <span className="badge bg-warning text-dark me-1">DTMF: {event.details.digit}</span>
              )}
              {event.details && event.details.selected_action && (
                <span className="badge bg-danger">{event.details.selected_action}</span>
              )}
            </div>
            <span className="timeline-time">
              {new Date(event.timestamp).toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' })}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default CallTimeline;
